
import { connect } from 'react-redux';
import ArtistsComponent from '../components/ArtistsComponent';
import { fetchDataArtistsIfNeeded } from '../actions/ArtistsActions';

const mapStateToProps = (state) => ({
    dataArtists: state.artists.ArtistsAll.dataArtists,
});


const mapDispatchToProps = (dispatch) => ({
    fetchDataArtistsIfNeeded: () => {
        dispatch(fetchDataArtistsIfNeeded());
    },
});

const ArtistsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ArtistsComponent);

export default ArtistsContainer;
